<template>
  <div class="loader-container">
    <button
      class="ui-button"
      type="button"
      @click="addPackageToBasket(basketPackage.id)"
    >
      {{ basketPackage.promptText }}
    </button>
    <Loader :loading="processing" />
  </div>
</template>
<script>
import Service from '@/services/Service.js';
import Loader from '@/components/Loader.vue';
export default {
  components: { Loader },
  props: {
    basketPackage: { type: Object, default: null }
  },
  data: function() {
    return {
      processing: false
    };
  },
  methods: {
    addPackageToBasket(packageId) {
      this.processing = true;
      this.$store
        .dispatch('ensureSession')
        .then(() => {
          var basketRequest = {};
          basketRequest.packageId = packageId;
          Service.addToBasket(basketRequest)
            .then(() => {
              this.$store
                .dispatch('loadBasket')
                .then(() => {
                  this.processing = false;
                  this.$store.dispatch('addMessage', {
                    message: 'Basket Updated',
                    timeout: 3000
                  });
                })
                .catch(error => {
                  this.processing = false;
                  this.$store.dispatch('addMessage', {
                    message: 'Error loading basket'
                  });
                  console.log(error);
                });
            })
            .catch(error => {
              switch (error.response.data.exceptionType) {
                case 'Monad.Data.PackageFailedException':
                  this.processing = false;
                  this.$router.push({
                    name: 'package',
                    params: {
                      packageId: packageId
                    }
                  });
                  break;
                case 'Monad.Data.OutOfStockException':
                  this.$store.dispatch('addMessage', {
                    message: 'Available Quantity Exceeded',
                    timeout: 3000
                  });
                  break;
                case 'Monad.Data.NotOnSaleException':
                  this.$store.dispatch('addMessage', {
                    message: 'Not On Sale',
                    timeout: 3000
                  });
                  break;
                case 'Monad.Data.ProductLimitException':
                  this.$store
                    .dispatch('loadBasket')
                    .then(() => {
                      this.setQuantities();
                      this.$store.dispatch('addMessage', {
                        message:
                          'Basket Updated. ' +
                          error.response.data.exceptionMessage,
                        timeout: 3000
                      });
                    })
                    .catch(error => {
                      this.$store.dispatch('addMessage', {
                        message: 'Error loading basket',
                        timeout: 3000
                      });
                      console.log(error);
                    });
                  break;
                default:
                  this.$store.dispatch('addMessage', {
                    message: 'Error adding to basket',
                    timeout: 3000
                  });
                  console.log(error);
              }
              this.processing = false;
              console.log(error.response);
            });
        })
        .catch(error => {
          this.processing = false;
          console.log(error.response);
        });
    }
  }
};
</script>
